import script from "./IndexPart3.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexPart3.vue?vue&type=script&setup=true&lang=js"

import "./IndexPart3.vue?vue&type=style&index=0&id=831454ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-831454ae"]])

export default __exports__